export const handleValidationErrors = (errors) => {
    let validationError = [];
    // Handle validation errors here
    for (const error of errors.inner) {
        const errorString = snakeToCamel(error.path);
        // populates the error message
        validationError[errorString] = error.message;
    }
    return validationError;
};

// converts strings like company_id to companyId
function snakeToCamel(str) {
    return str.replace(/_([a-z])/g, (_, match) => match.toUpperCase());
}
